import React, {useState, useEffect} from "react";
import {
    CourierStatsRow,
    CourierStatsWrapper,
    PoolShiftWrapper,
    TableContainer,
    StatsTable,
    TableBody,
    ToggleButton
} from "./CourierStatsWidget.styles";
import {CourierLink} from "../../../_defaultComponents/CourierLink/CourierLink";
import {Tag} from "antd";
import {DownOutlined, UpOutlined} from "@ant-design/icons";
import {useStore} from "../../../../hooks/useStore";
import {PoolCouriersDrawer} from "../../../pools/poolIntensities/poolCouriersDrawer/PoolCouriersDrawer";
import {TotalPoolDataTable} from "./PoolDataWidgetTables/TotalPoolDataTable";
import {PoolIntensitiesTableHeaders} from "./PoolDataWidgetTables/PoolIntensitiesTableHeaders";
import {PoolIntensitiesTableRows} from "./PoolDataWidgetTables/PoolIntensitiesTableRows";

export const CourierStatsWidget = ({
    courierStats,
    poolShiftDetails,
    selectedPool,
    integrationType
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedCourierData, setSelectedCourierData] = useState(null);
    const [poolsAvailableRates, setPoolsAvailableRates] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const stores = useStore();
    const isMobile = window.innerWidth <= 768;
    const availableStatuses = ["available", "ready"];
    const unavailableStatuses = ["unavailable"];
    const onDeliveryStatuses = [
        "busy",
        "assigned",
        "onTheWayForPickUp",
        "onPickUpAddress",
        "onDeliveryAddress",
        "onReturnAddress",
        "onDelivery",
        "onTheWayForReturn"
    ];

    useEffect(() => {
        const fetchPoolsAvailableRates = async () => {
            if (!selectedPool?.length) return;

            setLoading(true);
            try {
                const response = await stores.poolShiftStore.getPoolsAvailableRates();
                const filteredResponse = {
                    ...response,
                    data: response.data.filter(pool => {
                        if (!integrationType) return true;
                        return pool.integrationType === integrationType;
                    })
                };
                setPoolsAvailableRates(filteredResponse);
            } catch (error) {
                console.error("Error fetching pools available rates:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPoolsAvailableRates();
    }, [selectedPool, stores.poolShiftStore, integrationType]);

    const filteredPools =
        poolsAvailableRates?.data?.filter(pool => selectedPool?.some(sp => sp._id === pool._id)) ||
        [];

    const availableCourierFilter = status => availableStatuses.includes(status.courierStatus);
    const unavailableCourierFilter = status => unavailableStatuses.includes(status.courierStatus);
    const onDeliveryCourierFilter = status => onDeliveryStatuses.includes(status.courierStatus);
    const sortByCourierName = (status1, status2) => {
        return status1?.courier?.fullname && status2?.courier?.fullname
            ? status1?.courier?.fullname.localeCompare(status2?.courier?.fullname, "tr")
            : 1;
    };

    const handleCourierTypeClick = (pool, type) => {
        let recordType = "";
        switch (type) {
            case "inSlot":
                recordType = "Slot Seçen Kuryeler";
                break;
            case "unAvailable":
                recordType = "Meşgul Kuryeler";
                break;
            case "active":
                recordType = "Aktif Kuryeler";
                break;
            case "onDelivery":
                recordType = "Siparişteki Kuryeler";
                break;
            case "available":
                recordType = "Müsait Kuryeler";
                break;
        }

        setSelectedCourierData({
            poolName: pool.name,
            recordType,
            poolId: pool._id,
            type: type
        });
        setIsModalVisible(true);
    };

    return (
        <>
            {poolShiftDetails && poolShiftDetails !== null ? (
                <PoolShiftWrapper isMobile={isMobile}>
                    <ToggleButton onClick={() => setIsCollapsed(!isCollapsed)}>
                        {isCollapsed ? (
                            <>
                                <UpOutlined /> Havuz İstatistikleri
                            </>
                        ) : (
                            <>
                                <DownOutlined /> Gizle
                            </>
                        )}
                    </ToggleButton>

                    <Tag style={{marginRight: 8, backgroundColor: "#AEFF01", marginBottom: 10}}>
                        {poolShiftDetails?.currentPoolShiftHour?.activePoolShiftHour?.startTime} -{" "}
                        {poolShiftDetails?.currentPoolShiftHour?.activePoolShiftHour?.endTime}
                    </Tag>

                    <TableContainer isCollapsed={isCollapsed}>
                        <StatsTable>
                            <PoolIntensitiesTableHeaders />
                            <TableBody>
                                {filteredPools.map(pool => {
                                    return (
                                        <PoolIntensitiesTableRows
                                            key={pool._id}
                                            pool={pool}
                                            handleCourierTypeClick={handleCourierTypeClick}
                                        />
                                    );
                                })}
                                <TotalPoolDataTable filteredPools={filteredPools} />
                            </TableBody>
                        </StatsTable>
                    </TableContainer>
                </PoolShiftWrapper>
            ) : (
                <CourierStatsWrapper>
                    <div style={{border: "1px solid #D3D3D3", borderRadius: "5px", padding: "3px"}}>
                        <div style={{fontWeight: "bold"}}>
                            Toplam Kurye Sayısı: {courierStats?.length}
                        </div>
                        <div style={{fontWeight: "bold", color: "green"}}>
                            Müsait Kurye Sayısı:{" "}
                            {courierStats?.filter(availableCourierFilter)?.length}
                        </div>
                        <div style={{fontWeight: "bold", color: "red"}}>
                            Meşgul Kurye Sayısı:{" "}
                            {courierStats?.filter(unavailableCourierFilter)?.length}
                        </div>
                        <div style={{fontWeight: "bold", color: "orange"}}>
                            Siparişteki Kurye Sayısı:{" "}
                            {courierStats?.filter(onDeliveryCourierFilter)?.length}
                        </div>
                    </div>

                    <hr style={{width: "100%", margin: "15px 0"}} />
                    <div style={{fontWeight: "bold", color: "green", marginBottom: "5px"}}>
                        Müsait Kuryeler ({courierStats?.filter(availableCourierFilter)?.length}):
                    </div>
                    {courierStats
                        ?.filter(availableCourierFilter)
                        ?.sort(sortByCourierName)
                        ?.map(stats => (
                            <CourierStatsRow
                                key={stats._id.toString()}
                                style={{color: "green"}}
                                status="available"
                            >
                                <CourierLink
                                    target="_blank"
                                    to={`/couriers/${stats?.courier?._id}`}
                                >
                                    {stats?.courier?.fullname}
                                </CourierLink>
                            </CourierStatsRow>
                        ))}
                </CourierStatsWrapper>
            )}
            <PoolCouriersDrawer
                onClose={() => {
                    setIsModalVisible(false);
                    setSelectedCourierData(null);
                }}
                poolId={selectedCourierData?.poolId}
                type={selectedCourierData?.type}
                poolName={selectedCourierData?.poolName}
                visible={isModalVisible && selectedCourierData !== null}
            />
        </>
    );
};
